var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruApt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#89F7B6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8854 4.53863H9.65746C9.51465 4.53863 9.37841 4.47709 9.2834 4.37013L8.78565 3.80784C8.71155 3.72418 8.60459 3.67578 8.49285 3.67578C8.38111 3.67578 8.27415 3.72358 8.20006 3.80784L7.77281 4.29065C7.63299 4.4484 7.43221 4.53923 7.22128 4.53923H0.501316C0.310102 5.08479 0.185216 5.66082 0.13562 6.25896H6.47973C6.59147 6.25896 6.69783 6.21354 6.77491 6.13288L7.36588 5.51681C7.43938 5.43973 7.54156 5.39611 7.64793 5.39611H7.67242C7.78416 5.39611 7.89113 5.44391 7.96522 5.52816L8.46297 6.09045C8.55798 6.19741 8.69362 6.25896 8.83703 6.25896H14.0153C13.9657 5.66082 13.8409 5.08479 13.6496 4.53923H10.8854V4.53863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.97542 9.87275C4.08716 9.87275 4.19352 9.82733 4.2706 9.74667L4.86157 9.1306C4.93507 9.05352 5.03725 9.0099 5.14361 9.0099H5.16811C5.27985 9.0099 5.38681 9.0577 5.46091 9.14195L5.95866 9.70424C6.05367 9.8112 6.18931 9.87275 6.33272 9.87275H13.3503C13.6132 9.32958 13.8056 8.74638 13.9203 8.13629H7.18482C7.04201 8.13629 6.90577 8.07474 6.81076 7.96778L6.313 7.40549C6.23891 7.32184 6.13195 7.27344 6.02021 7.27344C5.90847 7.27344 5.80151 7.32124 5.72741 7.40549L5.30017 7.88831C5.16034 8.04606 4.95957 8.13689 4.74864 8.13689H0.231812C0.34654 8.74757 0.538951 9.33018 0.801869 9.87334H3.97542V9.87275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.95353 2.65911C9.06527 2.65911 9.17164 2.6137 9.24872 2.53303L9.83969 1.91696C9.91319 1.83988 10.0154 1.79626 10.1217 1.79626H10.1462C10.258 1.79626 10.3649 1.84406 10.439 1.92832L10.9368 2.4906C11.0318 2.59756 11.1674 2.65911 11.3108 2.65911H12.6451C11.3742 0.969858 9.35269 -0.123047 7.07606 -0.123047C4.79942 -0.123047 2.77793 0.969858 1.50696 2.65911H8.95413H8.95353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.27298 11.5933H4.44808C4.30527 11.5933 4.16903 11.5318 4.07402 11.4248L3.57627 10.8625C3.50217 10.7789 3.39521 10.7305 3.28347 10.7305C3.17173 10.7305 3.06477 10.7783 2.99067 10.8625L2.56343 11.3453C2.42361 11.5031 2.22283 11.5939 2.0119 11.5939H1.98322C3.25479 12.9563 5.06474 13.809 7.07547 13.809C9.0862 13.809 10.8962 12.9563 12.1677 11.5939H6.27298V11.5933Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruApt);
export default __webpack_public_path__ + "static/media/truApt.bd37b2df9d817183377375ae65b34614.svg";
export { ForwardRef as ReactComponent };